<script setup lang="ts">
  import type { TrainingDetail } from '@/entities/Training';
  import TrainingViewOpenInstructorsList from '../view/TrainingViewOpenInstructorsList.vue';

  defineProps<{
    instructors: TrainingDetail['instructors'];
    instructorType: TrainingDetail['instructorType'];
    externalInstructorCnpj: string | null;
    externalInstructorCompanyName: string | null;
  }>();
</script>

<template>
  <section
    data-testid="training-control-section-open-instructors"
    class="flex flex-col gap-4 border-b border-gray-02 px-6 py-8"
  >
    <h2 class="text-sm font-semibold text-gray-07">
      Ministrante
    </h2>

    <TrainingViewOpenInstructorsList
      :instructors="instructors"
      :instructor-type="instructorType"
      :external-instructor-cnpj="externalInstructorCnpj"
      :external-instructor-company-name="externalInstructorCompanyName"
    />
  </section>
</template>
